import {UI} from "../../../../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/ui/Style";

import {Messages} from "../../../../Messages";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import type {Subscription} from "../../../../../client/state/SubscriptionStore";


class SubscriptionOverviewStyle extends StyleSheet {
    @styleRule
    container = {
        paddingTop: 6,
        textAlign: "center",
        whiteSpace: "nowrap",
    };

    @styleRule
    boldInfo = {
        fontWeight: "bold",
        color: this.themeProps.MERCHANT_5,
    };

    @styleRule
    priceInfo = {
        color: this.themeProps.MERCHANT_2,
        display: "inline-block",
        marginLeft: 5,
    };
}

interface SubscriptionOverviewOptions {
    subscription?: Subscription;
}

@registerStyle(SubscriptionOverviewStyle)
export class SubscriptionOverview extends UI.Element<SubscriptionOverviewOptions> {
    render() {
        const {styleSheet} = this;
        const {subscription} = this.options;
        const {coverage} = subscription;

        const paidUntil = subscription.getPaidUntil();
        const nextBillingDate = subscription.getNextBillingDate();

        return subscription.isActiveButCanceled() ? [
            <div className={styleSheet.boldInfo}>{Messages.canceledSubscription}</div>,
            <div>
                <span className={styleSheet.boldInfo}>{coverage.name}</span>
                <span className={styleSheet.priceInfo}>
                    ({Messages.canceled})
                </span>
            </div>,
            paidUntil ? <div>{Messages.expiresOnDate(paidUntil)}</div> : null
        ] : [
            <div className={styleSheet.boldInfo}>{Messages.activeSubscriptionText}</div>,
            <div>
                <span className={styleSheet.boldInfo}>{coverage.name}</span>
            </div>,
            nextBillingDate ? <div>{Messages.nextBillingDate(nextBillingDate)}</div> : null
        ];
    }
}
